const DEFAULT_BOT_USERNAME = 'LeSIM_Global_bot'

/** @returns {string} Bot username without leading @ */
export function getTelegramBotUsername() {
  const raw = process.env.VUE_APP_TELEGRAM_BOT_USERNAME || DEFAULT_BOT_USERNAME
  return String(raw).trim().replace(/^@/, '')
}

/**
 * Build a Telegram referral deep link that opens the bot Mini App with the invitation code.
 * Uses startapp so start_param is included in WebApp initData.
 *
 * @param {string} code - Invitation / referral code
 * @returns {string} Deep link URL, or empty string if code is missing
 */
export function buildReferralDeepLink(code) {
  const trimmed = String(code || '').trim()
  if (!trimmed) return ''

  const bot = getTelegramBotUsername()
  const shortName = String(process.env.VUE_APP_TELEGRAM_MINIAPP_SHORT_NAME || '').trim()
  const encoded = encodeURIComponent(trimmed)

  if (shortName) {
    return `https://t.me/${bot}/${shortName}?startapp=${encoded}`
  }

  return `https://t.me/${bot}?startapp=${encoded}`
}
